import {
  DashboardBreakpoint,
  DashboardBreakpointMap,
  dashboardBreakpoints,
} from 'domain/dashboard/dashboard-model';
import { Widget, WidgetLayout, WidgetType } from 'domain/widget';

export function mapToLayoutsObject<T = WidgetLayout>(
  callback: (breakpoint: DashboardBreakpoint) => T,
): DashboardBreakpointMap<T> {
  return dashboardBreakpoints.reduce((result, current) => {
    result[current] = callback(current);

    return result;
  }, {} as DashboardBreakpointMap<T>);
}

export type WidgetMinimumDimensions = Required<Pick<WidgetLayout, 'minW' | 'minH'>>;

const widgetMinDimensions: Partial<Record<WidgetType, WidgetMinimumDimensions>> = {
  chart: {
    minW: 2,
    minH: 4,
  },
  file: {
    minW: 1,
    minH: 2,
  },
  fileSet: {
    minW: 2,
    minH: 4,
  },
  gallery: {
    minW: 2,
    minH: 3,
  },
  image: {
    minW: 1,
    minH: 2,
  },
  imageComparison: {
    minW: 2,
    minH: 3,
  },
  interactiveTable: {
    minW: 2,
    minH: 3,
  },
  notebook: {
    minW: 2,
    minH: 2,
  },
  scatterPlot: {
    minW: 2,
    minH: 4,
  },
  table: {
    minW: 2,
    minH: 2,
  },
  valueList: {
    minW: 1,
    minH: 2,
  },
};

export function getWidgetMinimumDimensions(
  breakpoint: DashboardBreakpoint,
  widget?: Widget,
): WidgetMinimumDimensions {
  const minDimensions = (widget && widgetMinDimensions[widget.type]) || { minW: 1, minH: 1 };

  if (breakpoint === 'xs') {
    return {
      ...minDimensions,
      minW: 1,
    };
  }

  return minDimensions;
}

export function getWidgetMinimumComparisonHeight(
  breakpoint: DashboardBreakpoint,
  widget?: Widget,
): number {
  if (widget?.type === 'imageComparison') {
    return 4;
  }

  return getWidgetMinimumDimensions(breakpoint, widget).minH;
}
